import API from './api';

export const markAttendance = async (attendanceData) => {
  try {
    const response = await API.post('/attendance', attendanceData);
    return response.data;
  } catch (error) {
    console.error('Error marking attendance:', error);
    throw error;
  }
};

export const updateMonthlyAttendance = async (workerMobileNumber, year, month, attendance) => {
  try {
    const response = await API.post('/attendance/monthly', {
      workerMobileNumber,
      year,
      month,
      attendance
    });
    return response.data;
  } catch (error) {
    console.error('Error updating monthly attendance:', error);
    throw error;
  }
};

export const getAttendanceForMonth = async (mobileNumber, year, month) => {
  try {
    const response = await API.get(`/attendance/${mobileNumber}/${year}/${month}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching attendance for ${mobileNumber}:`, error);
    throw error;
  }
};

// Get attendance by date for all users
export const getAttendanceByDate = async (date) => {
  try {
    const response = await API.post('/attendance/by-date', { date });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get attendance data for all users for a specific month (bulk API)
export const getAllUsersAttendanceForMonth = async (year, month) => {
  try {
    const response = await API.get(`/attendance/all-users/${year}/${month}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching attendance for all users for ${year}-${month}:`, error);
    throw error;
  }
};

const getSiteReport = async (siteId, startDate, endDate) => {
  try {
    const response = await API.post('/attendance/site-report', {
      siteId,
      startDate,
      endDate
    });
    return response.data;
  } catch (error) {
    console.error('Error getting site report:', error);
    throw error;
  }
};

const clearMonthData = async (monthYear) => {
  try {
    const response = await API.post('/attendance/clear-month', { monthYear });
    return response.data;
  } catch (error) {
    console.error('Error clearing month data:', error);
    throw error;
  }
};

// Temporary User Payment Functions
export const getTemporaryUserPayments = async (mobileNumber, startDate, endDate) => {
  try {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await API.get(`/users/temporary/${mobileNumber}/payments`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching temporary user payments for ${mobileNumber}:`, error);
    throw error;
  }
};

export const markTemporaryPaymentAsPaid = async (mobileNumber, date, narration = null) => {
  try {
    const requestData = { mobileNumber, date };
    if (narration) {
      requestData.narration = narration;
    }
    const response = await API.post(`/users/temporary/${mobileNumber}/payments/pay`, requestData);
    return response.data;
  } catch (error) {
    console.error(`Error marking payment as paid for ${mobileNumber} on ${date}:`, error);
    throw error;
  }
};

export const getTemporaryPaymentReport = async (mobileNumber) => {
  try {
    const response = await API.get(`/users/temporary/${mobileNumber}/payment-report`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching temporary payment report for ${mobileNumber}:`, error);
    throw error;
  }
};

export default {
  getAttendanceForMonth,
  getAttendanceByDate,
  markAttendance,
  getSiteReport,
  clearMonthData,
}; 